import React from "react";
import {
  Box,
  Skeleton,
  Card,
  CardContent,
  Accordion,
  AccordionSummary,
} from "@mui/material";

const ProfileSkeleton = () => {
  return (
    <Box>
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Skeleton variant="text" width={280} height={36} />
        <Skeleton variant="rectangular" width={140} height={36} sx={{ borderRadius: 1 }} />
      </Box>

      {/* Tabs row */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          borderBottom: 1,
          borderColor: "divider",
          pb: 1,
          mb: 2,
          overflow: "hidden",
        }}
      >
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" width={80} height={36} />
        ))}
      </Box>

      {/* Tab content - Overview with accordions */}
      <Box sx={{ p: 2 }}>
        <Skeleton variant="text" width={120} height={28} sx={{ mb: 2 }} />
        {Array.from({ length: 3 }).map((_, accordionIdx) => (
          <Accordion key={accordionIdx} sx={{ mb: 2 }} expanded>
            <AccordionSummary>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, width: "100%" }}>
                <Skeleton variant="text" width={180} height={24} sx={{ flexGrow: 1 }} />
                <Skeleton variant="rounded" width={60} height={24} />
              </Box>
            </AccordionSummary>
            <Box sx={{ px: 2, pb: 2 }}>
              {Array.from({ length: 2 }).map((_, cardIdx) => (
                <Card key={cardIdx} variant="outlined" sx={{ mb: 1 }}>
                  <CardContent>
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "start" }}>
                      <Box sx={{ flexGrow: 1 }}>
                        <Skeleton variant="text" width="70%" height={20} />
                        <Skeleton variant="text" width="50%" height={16} />
                        <Skeleton variant="text" width="40%" height={14} />
                      </Box>
                      <Skeleton variant="rounded" width={80} height={24} />
                    </Box>
                  </CardContent>
                </Card>
              ))}
            </Box>
          </Accordion>
        ))}
      </Box>
    </Box>
  );
};

export default ProfileSkeleton;
